<div nz-row nzGutter="25">
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Basic</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-breadcrumb-basic></nz-demo-breadcrumb-basic>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">With Icon</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-breadcrumb-with-icon></nz-demo-breadcrumb-with-icon>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Breadcrumbs with drop down menu</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-breadcrumb-dropdown></nz-demo-breadcrumb-dropdown>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Configuring the Separator</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-breadcrumb-separator></nz-demo-breadcrumb-separator>
      </div>
    </div>
  </div>
</div>
